/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const PhoneIcon = ({ className }) => (
  <svg
    className={className}
    width="25px"
    height="23px"
    viewBox="0 0 400 400"
    version="1.2"
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      fill="currentColor"
      d="M396.8 28.6L294.9 130.5h57.9c6.2 0 11.3 5 11.3 11.3 0 6.2-5 11.3-11.3 11.3h-85.1c-1.5 0-2.9-.3-4.3-.9-1.3-.5-2.4-1.3-3.4-2.2-.1-.1-.2-.1-.3-.2-.1-.1-.1-.2-.2-.3-.9-1-1.7-2.1-2.2-3.4-.6-1.4-.9-2.8-.9-4.3V57.5c0-6.2 5-11.3 11.3-11.3s11.3 5 11.3 11.3v57.1l101.8-102c4.4-4.4 11.5-4.4 15.9 0 4.5 4.4 4.5 11.6.1 16zm-65.5 355c7.5-6.1 12.3-11.3 17.9-17.3l37.2-40.5c5.7-6.2 5.6-15.8-.4-21.9 0 0-42-42.4-54.2-54.5-6.7-6.6-17.3-6.7-24.2-.4l-1.7 1.9c-.6.8-3.6 4.5-15.6 17.7-14.9 16.4-23 10.2-34.2 1.7l-3-2.2c-15.3-11.1-27.7-22.8-40.8-35.2-4.7-4.5-9.4-8.9-14.3-13.4-28.2-25.7-55.2-51.3-75.7-83.3-5.4-8.5-4.4-19.3 2.6-26.3 0 0 15.9-16 22.8-23.5 6.5-7.1 6.2-17.9-.6-24.8L90.3 5.1l-3-2.7c-3.6-3.3-9.2-3.3-12.8.1L22.2 52.1C8 66.2.3 85 .3 105.8c0 15.1 4.5 29.7 13 42.2 1.3 1.9 32.1 46.5 44.3 60.7 29.4 34 120.1 132.5 188.1 180.1 11.8 7.3 25.4 11.2 39.3 11.2 16.8 0 33.3-5.8 46.3-16.4zM123.8 74.5c-7.4 7.7-17.1 17.4-17.1 17.4-15.5 15.5-18 39.4-6 58 22.2 34.6 50.5 61.5 80 88.4 4.8 4.3 9.4 8.7 14 13.1 13.1 12.4 26.7 25.2 43.4 37.3l2.5 1.9c10.4 7.9 37.8 28.8 68.5-4.8 4.4-4.8 8.1-8.9 11-12.2 11.7 11.7 31.4 31.5 41.4 41.6l-30.9 33.6c-5.2 5.5-9.2 9.9-15.3 14.9-15.5 12.6-38.9 13.9-56.1 3.4C194.5 321.8 105.7 225.4 76.9 192c-11.3-13.1-42.3-58.1-42.6-58.5-5.6-8.2-8.6-17.8-8.6-28.6 0-13 5.3-25.6 14.4-34.8l39.5-39.5 44.2 43.9zm244 247.2zm-.1-13.1z"
    />
  </svg>
);

export default PhoneIcon;
